import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import {
  Settings,
  Email,
  Api,
  ManageAccounts,
  PieChart,
  MonitorHeart
} from '@mui/icons-material';
import EmailSettings from './EmailSettings';
import APISettings from './APISettings';
import UserSettings from './UserSettings';
import UserRoleDistribution from './UserRoleDistribution';
import UserMonitoringDashboard from './UserMonitoringDashboard';

const SettingsDashboard = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: 'primary.main', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Settings /> System Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Configure all system settings, user management, and monitoring
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              minHeight: 64,
              textTransform: 'none',
              fontSize: '0.95rem',
              fontWeight: 500,
            }
          }}
        >
          <Tab 
            icon={<Email />} 
            iconPosition="start" 
            label="Email Settings" 
          />
          <Tab 
            icon={<Api />} 
            iconPosition="start" 
            label="API Settings" 
          />
          <Tab 
            icon={<ManageAccounts />} 
            iconPosition="start" 
            label="User Settings" 
          />
          <Tab 
            icon={<PieChart />} 
            iconPosition="start" 
            label="User Role Distribution" 
          />
          <Tab 
            icon={<MonitorHeart />} 
            iconPosition="start" 
            label="User Monitoring" 
          />
        </Tabs>

        <Box sx={{ p: 0 }}>
          {tabValue === 0 && <EmailSettings />}
          {tabValue === 1 && <APISettings />}
          {tabValue === 2 && <UserSettings />}
          {tabValue === 3 && <UserRoleDistribution />}
          {tabValue === 4 && <UserMonitoringDashboard />}
        </Box>
      </Paper>
    </Container>
  );
};

export default SettingsDashboard;
